import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData,
} from "@remix-run/react";
import { json } from "@remix-run/node";
import type { LinksFunction, LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import stylesheet from "~/tailwind.css?url";

export const meta: MetaFunction = () => [
  { title: "Bloodhound — Monitor every Shopify store" },
  { name: "description", content: "Monitor errors, performance, scripts, and security across all your Shopify stores from one dashboard." },
  { property: "og:title", content: "Bloodhound" },
  { property: "og:description", content: "Monitor every Shopify store from one place." },
  { property: "og:image", content: "https://dashboard.getbloodhound.app/icon.svg" },
  { name: "robots", content: "noindex, nofollow" },
];

export const links: LinksFunction = () => [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap",
  },
  { rel: "stylesheet", href: stylesheet },
];

export async function loader({ request }: LoaderFunctionArgs) {
  const cookie = request.headers.get("Cookie") ?? "";
  const theme = cookie.match(/(?:^|;\s*)theme=([^;]+)/)?.[1] ?? "dark";
  return json({ theme: theme === "light" ? "light" : "dark" });
}

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en" className="h-full dark">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {/* Prevent flash: removes dark class if user chose light */}
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(){try{var t=document.cookie.match(/(?:^|;\\s*)theme=([^;]+)/);if(t&&t[1]==='light')document.documentElement.classList.remove('dark');}catch(e){}})();`,
          }}
        />
        <Meta />
        <Links />
      </head>
      <body className="h-full font-sans antialiased bg-white dark:bg-[#050505]">
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  return <Outlet />;
}
